import http from './http';
import socket from './socket';
import { transformAttachment } from './transformers';

/* Actions */

const createAttachment = (cardId, data, requestId, headers) =>
  http.post(`/cards/${cardId}/attachments?requestId=${requestId}`, data, headers).then((body) => ({
    ...body,
    item: transformAttachment(body.item),
  }));

const createWireframe = (cardId, data, requestId, headers) =>
  socket.post(`/cards/${cardId}/wireframes?requestId=${requestId}`, data, headers).then((body) => ({
    ...body,
    item: transformAttachment(body.item),
  }));

const updateAttachment = (id, data, headers) =>
  socket.patch(`/attachments/${id}`, data, headers).then((body) => ({
    ...body,
    item: transformAttachment(body.item),
  }));

const updateWireframe = (id, data, updatedAt, headers) =>
  socket
    .patch(`/wireframes/${id}`, data, {
      ...headers,
      ...(updatedAt && {
        'If-Unmodified-Since': updatedAt instanceof Date ? updatedAt.toUTCString() : new Date(updatedAt).toUTCString(),
      }),
    })
    .then((body) => ({
      ...body,
      item: transformAttachment(body.item),
    }));

const deleteAttachment = (id, headers) =>
  socket.delete(`/attachments/${id}`, undefined, headers).then((body) => ({
    ...body,
    item: transformAttachment(body.item),
  }));

/* Event handlers */

const makeHandleAttachmentCreate = (next) => (body) => {
  next({
    ...body,
    item: transformAttachment(body.item),
  });
};

const makeHandleAttachmentUpdate = makeHandleAttachmentCreate;

const makeHandleAttachmentDelete = makeHandleAttachmentCreate;

export default {
  createAttachment,
  createWireframe,
  updateAttachment,
  updateWireframe,
  deleteAttachment,
  makeHandleAttachmentCreate,
  makeHandleAttachmentUpdate,
  makeHandleAttachmentDelete,
};
